import OutsideClickHandler from "react-outside-click-handler";
import { Form } from "react-bootstrap";
import { Controller } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { isMobile } from "react-device-detect";
import { IoClose } from "react-icons/io5";
const ModalPhone = ({
  setShow,
  handleSubmit1,
  onSubmit1,
  errors1,
  verifyEdit,
  control1,
  inputRef,
  register1,
  isLoader1,
}) => {
  return (
    <div
      role="document"
      tabIndex={0}
      data-v-c5353408
      className="v-dialog__content v-dialog__content--active"
      style={{ "z-index": "202" }}
    >
      <div
        className="v-dialog v-dialog--active v-dialog--persistent"
        style={{
          "-webkit-transform-origin": "center center",
          "-ms-transform-origin": "center center",
          "transform-origin": "center center",
          "max-width": "450px",
        }}
      >
        <OutsideClickHandler onOutsideClick={() => setShow(false)}>
          <div
            data-v-c5353408
            className="dialog-card v-card v-sheet theme--light"
          >
            <div
              data-v-c5353408
              className="row no-gutters justify-space-between dialog-header pt-3 px-3"
            >
              <div data-v-c5353408 className="col col-11">
                <label
                  data-v-c5353408
                  className="dialog-title pt-3 ma-0 text-capitalize d-block full-width"
                >
                  Add Mobile
                </label>
              </div>
              <div
                onClick={() => setShow(false)}
                data-v-c5353408
                className="col col-1"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IoClose />
              </div>
            </div>
            <div data-v-c5353408 className="row no-gutters px-3 py-3">
              <div data-v-c5353408 className="col col-12">
                <hr
                  data-v-c5353408
                  role="separator"
                  aria-orientation="horizontal"
                  className="dialog-divider v-divider theme--light"
                />
              </div>
            </div>
            <div
              data-v-c5353408
              className="row d-block dialog-row no-gutters pa-3 pt-0"
            >
              <div className="row no-gutters">
                <div className="am-popup-body">
                  <Form onSubmit={handleSubmit1(onSubmit1)}>
                    {" "}
                    <div
                      className="vc-scroll-container "
                      style={{ height: "100%" }}
                    >
                      <div className="vc-v2-container ">
                        {verifyEdit?.phoneStatus == "add" && (
                          <>
                            <div className="ranndom-container">
                              <div className="col col-10">
                                <label
                                  className="input-field-label ma-0 text-capitalize d-block pb-1"
                                  style={{ float: "left" }}
                                >
                                  Mobile Number
                                  <span className="red--text ml-1">*</span>
                                </label>
                              </div>
                              <div className="vc-v2-input no-border">
                                <div className="col col-12">
                                  <div
                                    style={{
                                      width: "100%",
                                      flexDirection: "column",
                                    }}
                                    className="v-input input-field elevation-0 hide-details v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder"
                                  >
                                    <div className="v-input__control">
                                      <div className="v-text-field__slot">
                                        <Controller
                                          className="form-group d-flex"
                                          control={control1}
                                          name="mobile"
                                          rules={{
                                            required:
                                              "Please enter mobile number.",
                                            validate: (value) => {
                                              let inputValue = value
                                                ?.toString()
                                                ?.slice(
                                                  inputRef?.current?.state
                                                    ?.selectedCountry
                                                    ?.countryCode?.length,
                                                  value?.length,
                                                );
                                              if (inputValue?.length < 10) {
                                                return "Mobile number must contain 10 digit";
                                              } else if (
                                                inputValue?.length > 12
                                              ) {
                                                return "Mobile number should not exceed 12 digit";
                                              } else {
                                                return true;
                                              }
                                            },
                                          }}
                                          render={({
                                            field: { ref, ...field },
                                          }) => (
                                            <>
                                              <PhoneInput
                                                {...field}
                                                inputExtraProps={{
                                                  ref,
                                                  required: true,
                                                  autoFocus: true,
                                                }}
                                                ref={inputRef}
                                                inputStyle={{
                                                  width: "100%",
                                                  height: "38px",
                                                }}
                                                country={"bd"}
                                                enableSearch
                                                countryCodeEditable={false}
                                              />
                                            </>
                                          )}
                                        />
                                      </div>{" "}
                                    </div>{" "}
                                    {errors1.mobile &&
                                      errors1.mobile.message && (
                                        <div className="v-text-field__details">
                                          <div
                                            className="v-messages theme--light error--text"
                                            role="alert"
                                          >
                                            <div className="v-messages__wrapper">
                                              <div className="v-messages__message">
                                                {errors1.mobile.message}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </div>{" "}
                            </div>
                          </>
                        )}

                        <div className="col-md-6 col">
                          <div className="mobile">
                            <div className="row no-gutters justify-space-between">
                              <div className="col col-10">
                                <label
                                  className="input-field-label ma-0 text-capitalize d-block pb-1"
                                  style={{ float: "left" }}
                                >
                                  Password
                                </label>
                              </div>
                              <div className="col col-12">
                                <div className="v-input input-field elevation-0 hide-details v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                                  <div className="v-input__control">
                                    <div className="v-input__slot">
                                      <fieldset aria-hidden="true">
                                        <legend style={{ width: "0px" }}>
                                          <span className="notranslate">​</span>
                                        </legend>
                                      </fieldset>
                                      <div className="v-text-field__slot">
                                        <input
                                          autoComplete="new-password"
                                          id="input-608"
                                          type="text"
                                          {...register1("verificationCode", {
                                            required: "Please enter password",
                                          })}
                                        />
                                      </div>
                                    </div>
                                    {errors1.verificationCode &&
                                      errors1.verificationCode.message && (
                                        <div className="v-text-field__details">
                                          <div
                                            className="v-messages theme--light error--text"
                                            role="alert"
                                          >
                                            <div className="v-messages__wrapper">
                                              <div className="v-messages__message">
                                                {
                                                  errors1.verificationCode
                                                    .message
                                                }
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row pb-5 breakpoint no-gutters align-end px-8 pt-2">
                          <div className="col-md-6 col">
                            <button
                              disabled={isLoader1}
                              type="submit"
                              className={`theme-button depo-width black--text v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default ${
                                isMobile
                                  ? "deposit-btn buttonPrimary"
                                  : "deposit-btn-desktop"
                              }`}
                            >
                              <span className="v-btn__content"> Submit</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>{" "}
        </OutsideClickHandler>
      </div>
    </div>
  );
};

export default ModalPhone;
